<form [formGroup]="positionForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Выберите позицию</h3>
  <div mat-dialog-content>
    <div class="form">
      <mat-form-field>
        <mat-label>Позиция</mat-label>
        <input matInput formControlName="position" placeholder="Укажите позицию"
               type="number"
               [min]="minPosition"
               [max]="maxPosition"
               required
               cdkFocusInitial>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Выбрать
    </button>
  </div>
</form>
